// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t97j","index":"styles_index__2FQDH"};